<template>
    <div class="ah-page analysis-compare-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>同期比較</h1>
                    </div>
                    <div class="actions">
                        <el-button type="dark" @click="isShowSetting = isShowSetting ? false : true">自訂比較區間</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel" v-if="isShowSetting">
                <div class="panel-header small gray">
                    <div class="panel-title">自訂比較區間</div>
                </div>
                <div class="panel-body" style="text-align: center">
                    <div class="timespan-group">
                        <span class="compare-label categ-a" style="padding: 0 20px; font-weight: bold; color: #453bb1">A</span>
                        <el-select v-model="conditions.YearA" placeholder="年度" style="width: 150px; margin-right: 8px">
                            <el-option v-for="item in yearList" :key="item" :label="item" :value="item" />
                        </el-select>
                        <el-select v-model="conditions.StartMonthA" placeholder="請選擇" style="width: 120px" @change="handleStartMonthAChange">
                            <el-option v-for="item in monthOptions" :key="item.key" :label="item.value" :value="item.key" />
                        </el-select>
                        ~
                        <el-select v-model="conditions.EndMonthA" placeholder="請選擇" style="width: 120px" @change="handleEndMonthAChange">
                            <el-option v-for="item in monthOptions" :key="item.key" :label="item.value" :value="item.key" />
                        </el-select>
                    </div>
                    <div class="timespan-group" style="margin-top: 10px">
                        <span class="compare-label categ-b" style="padding: 0 20px; font-weight: bold; color: #ffa200">B</span>
                        <el-select v-model="conditions.YearB" placeholder="年度" style="width: 150px; margin-right: 8px">
                            <el-option v-for="item in yearList" :key="item" :label="item" :value="item" />
                        </el-select>
                        <el-select v-model="conditions.StartMonthB" placeholder="請選擇" style="width: 120px">
                            <el-option v-for="item in monthOptions" :key="item.key" :label="item.value" :value="item.key" />
                        </el-select>
                        ~
                        <el-select v-model="conditions.EndMonthB" placeholder="請選擇" style="width: 120px">
                            <el-option v-for="item in monthOptions" :key="item.key" :label="item.value" :value="item.key" />
                        </el-select>
                    </div>
                    <el-button type="primary" @click="fetchData" style="margin-top: 30px">比較</el-button>
                </div>
            </div>
            <div class="ah-panel">
                <div class="panel-header small gray">
                    <div class="panel-title">總比較</div>
                    <div class="al-panel-tabs" style="padding-right: 20px; background-color: unset">
                        <div class="right">
                            <div
                                :class="{
                                    item: true,
                                    active: tabs.all == 'table'
                                }"
                                @click="handleTabClick('all', 'table')"
                                @keydown="() => {}"
                            >
                                <span class="name"><i class="el-icon-s-grid"></i> 表格</span>
                            </div>
                            <div
                                :class="{
                                    item: true,
                                    active: tabs.all == 'chart'
                                }"
                                @click="handleTabClick('all', 'chart')"
                                @keydown="() => {}"
                            >
                                <span class="name"><i class="el-icon-s-data"></i> 圖表</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-body">
                    <div v-if="tabs.all == 'chart'">
                        <div class="chart-labels">
                            <div class="item a">
                                <div class="title">A</div>
                                <div class="timespan">
                                    {{ conditions.YearA + " 年 " + conditions.StartMonthA + "月 ~ " + conditions.EndMonthA + "月" }}
                                </div>
                            </div>
                            <div class="item b">
                                <div class="title">B</div>
                                <div class="timespan">
                                    {{ conditions.YearB + " 年 " + conditions.StartMonthB + "月 ~ " + conditions.EndMonthB + "月" }}
                                </div>
                            </div>
                        </div>
                        <v-chart :option="allChartOption" style="width: 100%; height: 220px" />
                    </div>
                    <div v-if="tabs.all == 'table'">
                        <table class="compare-table2" cellspacing="0" cellpadding="0">
                            <thead>
                                <tr>
                                    <th class="item-name"></th>
                                    <th class="item-a">
                                        <div class="title">A</div>
                                        <div class="head-date">
                                            {{ conditions.YearA + " 年 " + conditions.StartMonthA + "月 ~ " + conditions.EndMonthA + "月" }}
                                        </div>
                                    </th>
                                    <th class="item-b">
                                        <div class="title">B</div>
                                        <div class="head-date">
                                            {{ conditions.YearB + " 年 " + conditions.StartMonthB + "月 ~ " + conditions.EndMonthB + "月" }}
                                        </div>
                                    </th>
                                    <th class="item-amt">
                                        <div>增減</div>
                                        <div><span class="b-font">B</span> - <span class="a-font">A</span></div>
                                    </th>
                                    <th class="item-percent">百分比</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in pageData.amountComparisonForm" :key="'all-' + index">
                                    <td class="item-name">{{ item.title }}</td>
                                    <td class="item-a">
                                        <Money :v="item.amountA" round />
                                    </td>
                                    <td class="item-b">
                                        <Money :v="item.amountB" round />
                                    </td>
                                    <td class="item-amt">
                                        <span>
                                            <span class="increase diff-sign" v-if="item.comparisonValue > 0"></span>
                                            <span class="decrease diff-sign" v-if="item.comparisonValue < 0"></span>
                                            <Money :v="item.comparisonValue" round abs />
                                        </span>
                                    </td>
                                    <td class="item-percent">
                                        <span class="increase diff-sign" v-if="item.comparisonValue > 0"></span>
                                        <span class="decrease diff-sign" v-if="item.comparisonValue < 0"></span>
                                        <span v-if="checkIsValidPercentNumber(item)">{{ Math.abs(item.comparisonPercent) }}%</span>
                                        <span v-else> -- </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="ah-panel">
                <div class="panel-header small gray">
                    <div class="panel-title">
                        營業收入比較
                        <ahTip>收入項目大群組 ＋ 營業其他收入</ahTip>
                    </div>
                    <div class="al-panel-tabs" style="padding-right: 20px; background-color: unset">
                        <div class="right">
                            <div
                                :class="{
                                    item: true,
                                    active: tabs.income == 'table'
                                }"
                                @click="handleTabClick('income', 'table')"
                                @keydown="() => {}"
                            >
                                <span class="name"><i class="el-icon-s-grid"></i> 表格</span>
                            </div>
                            <div
                                :class="{
                                    item: true,
                                    active: tabs.income == 'chart'
                                }"
                                @click="handleTabClick('income', 'chart')"
                                @keydown="() => {}"
                            >
                                <span class="name"><i class="el-icon-s-data"></i> 圖表</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-body">
                    <div v-if="tabs.income == 'chart'">
                        <div class="chart-labels">
                            <div class="item a">
                                <div class="title">A</div>
                                <div class="timespan">
                                    {{ conditions.YearA + " 年 " + conditions.StartMonthA + "月 ~ " + conditions.EndMonthA + "月" }}
                                </div>
                            </div>
                            <div class="item b">
                                <div class="title">B</div>
                                <div class="timespan">
                                    {{ conditions.YearB + " 年 " + conditions.StartMonthB + "月 ~ " + conditions.EndMonthB + "月" }}
                                </div>
                            </div>
                        </div>
                        <v-chart :option="incomeChartOption" style="width: 100%; height: 220px" />
                    </div>
                    <div v-if="tabs.income == 'table'">
                        <table class="compare-table2" cellspacing="0" cellpadding="0">
                            <thead>
                                <tr>
                                    <th class="item-name"></th>
                                    <th class="item-a" colspan="2">
                                        <div class="title">A</div>
                                        <div class="head-date">
                                            {{ conditions.YearA + " 年 " + conditions.StartMonthA + "月 ~ " + conditions.EndMonthA + "月" }}
                                        </div>
                                    </th>
                                    <th class="item-b" colspan="2">
                                        <div class="title">B</div>
                                        <div class="head-date">
                                            {{ conditions.YearB + " 年 " + conditions.StartMonthB + "月 ~ " + conditions.EndMonthB + "月" }}
                                        </div>
                                    </th>
                                    <th class="item-amt">
                                        <span style="cursor: pointer; text-decoration: underline" @click="onToggleIncomeTaxJoin">增減（{{ currentTaxMode }}）</span>
                                        <div><span class="b-font">B</span> - <span class="a-font">A</span></div>
                                    </th>
                                    <th class="item-percent">百分比</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td></td>
                                    <td class="td-center">銷售額(未稅)</td>
                                    <td class="td-center">稅金</td>
                                    <td class="td-center">銷售額(未稅)</td>
                                    <td class="td-center">稅金</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr v-for="(item, index) in pageData.incomeComparisonForm" :key="'income-' + index">
                                    <td class="item-name">{{ item.title }}</td>
                                    <td class="item-a no-tax">
                                        <Money :v="item.noTaxAmountA" round />
                                    </td>
                                    <td class="item-a tax">
                                        <Money :v="item.taxA" round />
                                    </td>
                                    <td class="item-b no-tax">
                                        <Money :v="item.noTaxAmountB" round />
                                    </td>
                                    <td class="item-b tax">
                                        <Money :v="item.taxB" round />
                                    </td>
                                    <td class="item-amt">
                                        <span class="increase diff-sign" v-if="item.comparisonValue > 0"></span>
                                        <span class="decrease diff-sign" v-if="item.comparisonValue < 0"></span>
                                        <Money :v="getIncomeComparisonValue(item)" round abs />
                                    </td>
                                    <td class="item-percent">
                                        <span class="increase diff-sign" v-if="item.comparisonValue > 0"></span>
                                        <span class="decrease diff-sign" v-if="item.comparisonValue < 0"></span>
                                        <span v-if="checkIsValidPercentNumber(item)">{{ getIncomeComparisonPercent(item) }}%</span>
                                        <span v-else> -- </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="ah-panel">
                <div class="panel-header small gray">
                    <div class="panel-title">
                        營業支出比較
                        <ahTip>人事薪資 ＋ 支出項目大群組 ＋ 其他支出</ahTip>
                    </div>
                    <div class="al-panel-tabs" style="padding-right: 20px; background-color: unset">
                        <div class="right">
                            <div
                                :class="{
                                    item: true,
                                    active: tabs.payout == 'table'
                                }"
                                @click="handleTabClick('payout', 'table')"
                                @keydown="() => {}"
                            >
                                <span class="name"><i class="el-icon-s-grid"></i> 表格</span>
                            </div>
                            <div
                                :class="{
                                    item: true,
                                    active: tabs.payout == 'chart'
                                }"
                                @click="handleTabClick('payout', 'chart')"
                                @keydown="() => {}"
                            >
                                <span class="name"><i class="el-icon-s-data"></i> 圖表</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-body">
                    <div v-if="tabs.payout == 'chart'">
                        <div class="chart-labels">
                            <div class="item a">
                                <div class="title">A</div>
                                <div class="timespan">
                                    {{ conditions.YearA + " 年 " + conditions.StartMonthA + "月 ~ " + conditions.EndMonthA + "月" }}
                                </div>
                            </div>
                            <div class="item b">
                                <div class="title">B</div>
                                <div class="timespan">
                                    {{ conditions.YearB + " 年 " + conditions.StartMonthB + "月 ~ " + conditions.EndMonthB + "月" }}
                                </div>
                            </div>
                        </div>
                        <v-chart :option="payoutChartOption" style="width: 100%; height: 220px" />
                    </div>
                    <div v-if="tabs.payout == 'table'">
                        <table class="compare-table2" cellspacing="0" cellpadding="0">
                            <thead>
                                <tr>
                                    <th class="item-name"></th>
                                    <th class="item-a">
                                        <div class="title">A</div>
                                        <div class="head-date">
                                            {{ conditions.YearA + " 年 " + conditions.StartMonthA + "月 ~ " + conditions.EndMonthA + "月" }}
                                        </div>
                                    </th>
                                    <th class="item-b">
                                        <div class="title">B</div>
                                        <div class="head-date">
                                            {{ conditions.YearB + " 年 " + conditions.StartMonthB + "月 ~ " + conditions.EndMonthB + "月" }}
                                        </div>
                                    </th>
                                    <th class="item-amt">
                                        <div>增減</div>
                                        <div><span class="b-font">B</span> - <span class="a-font">A</span></div>
                                    </th>
                                    <th class="item-percent">百分比</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in pageData.payoutComparisonForm" :key="'payout-' + index">
                                    <td class="item-name">{{ item.title }}</td>
                                    <td class="item-a">
                                        <Money :v="item.amountA" round />
                                    </td>
                                    <td class="item-b">
                                        <Money :v="item.amountB" round />
                                    </td>
                                    <td class="item-amt">
                                        <span class="increase diff-sign" v-if="item.amountA < item.amountB"></span>
                                        <span class="decrease diff-sign" v-if="item.amountA > item.amountB"></span>
                                        <Money :v="item.comparisonValue" round abs />
                                    </td>
                                    <td class="item-percent">
                                        <span class="increase diff-sign" v-if="item.comparisonValue > 0"></span>
                                        <span class="decrease diff-sign" v-if="item.comparisonValue < 0"></span>
                                        <span v-if="checkIsValidPercentNumber(item)">{{ Math.abs(item.comparisonPercent) }}%</span>
                                        <span v-else> -- </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { monthOptions } from '@/assets/commonData/options';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
    TitleComponent, TooltipComponent, LegendComponent, GridComponent,
} from 'echarts/components';
import VChart from 'vue-echarts';
import moment from 'moment';

use([CanvasRenderer, PieChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent]);
export default {
    name: 'AnalysisComparison',
    components: {
        VChart,
    },
    data() {
        return {
            isIncomeTaxJoin: true,
            isShowSetting: false,
            monthOptions,
            conditions: {
                YearA: new Date().getFullYear(),
                StartMonthA: 1,
                EndMonthA: 12,
                YearB: new Date().getFullYear(),
                StartMonthB: 1,
                EndMonthB: 12,
            },
            pageData: {},
            yearList: [],
            tabs: {
                all: 'table',
                income: 'table',
                payout: 'table',
            },
            allChartOption: {
                tooltip: {
                    trigger: 'axis',
                },
                grid: {
                    top: 20,
                    left: 20,
                    bottom: 20,
                    right: 20,
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    data: ['營業收入', '營業支出', '營業淨收'],
                },
                yAxis: {
                    show: true,
                    type: 'value',
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: true,
                    },
                },
                series: [
                    {
                        name: 'A',
                        type: 'bar',
                        animation: false,
                        data: [100, 400, 300],
                        itemStyle: {
                            normal: {
                                color: '#463cb2',
                            },
                        },
                    },
                    {
                        name: 'B',
                        type: 'bar',
                        animation: false,
                        data: [300, 200, 250],
                        itemStyle: {
                            normal: {
                                color: '#ffa200',
                            },
                        },
                    },
                ],
            },
            incomeChartOption: {
                tooltip: {
                    trigger: 'axis',
                },
                grid: {
                    top: 20,
                    left: 20,
                    bottom: 20,
                    right: 20,
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    data: [],
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: false,
                    },
                },
                series: [
                    {
                        name: 'A',
                        type: 'bar',
                        animation: false,
                        data: [100, 400, 300],
                        itemStyle: {
                            normal: {
                                color: '#463cb2',
                            },
                        },
                    },
                    {
                        name: 'B',
                        type: 'bar',
                        animation: false,
                        data: [300, 200, 250],
                        itemStyle: {
                            normal: {
                                color: '#ffa200',
                            },
                        },
                    },
                ],
            },
            payoutChartOption: {
                tooltip: {
                    trigger: 'axis',
                },
                grid: {
                    top: 20,
                    left: 20,
                    bottom: 20,
                    right: 20,
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    data: [],
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: false,
                    },
                },
                series: [
                    {
                        name: 'A',
                        type: 'bar',
                        animation: false,
                        data: [100, 400, 300],
                        itemStyle: {
                            normal: {
                                color: '#463cb2',
                            },
                        },
                    },
                    {
                        name: 'B',
                        type: 'bar',
                        animation: false,
                        data: [300, 200, 250],
                        itemStyle: {
                            normal: {
                                color: '#ffa200',
                            },
                        },
                    },
                ],
            },
        };
    },
    computed: {
        currentTaxMode() {
            return this.isIncomeTaxJoin ? '含稅' : '未稅';
        },
    },
    async created() {
        await this.fetchYearOptions();
        await this.fetchData();
    },
    methods: {
        handleTabClick(categ, type) {
            this.tabs[categ] = type;
        },
        async fetchYearOptions() {
            const resp = await this.$api({
                url: 'FinancialAnalysisPage/GetComparisonYearOptions',
                method: 'GET',
            });
            this.status = 'success';

            if (resp.data.options?.length > 0) this.yearList = resp.data.options.reverse();
            else this.yearList = [new Date().getFullYear()];

            const THIS_YEAR = moment().year();
            if (this.yearList.find((o) => o < THIS_YEAR)) {
                this.conditions.YearA = THIS_YEAR - 1;
                this.conditions.YearB = THIS_YEAR;
            } else this.conditions.YearA = THIS_YEAR;
        },
        countDiffPercent(a, b) {
            const diff = a - b;
            const v = (diff / a) * 100;
            return Math.round(v * 10) / 10;
        },
        async fetchData() {
            const result = await this.$api({
                url: 'FinancialAnalysisPage/GetComparison',
                params: this.conditions,
                method: 'GET',
            });
            this.pageData = result.data;
            console.log(result.data);

            // 總比較 補計算百分比
            for (let i = 0; i < this.pageData.amountComparisonForm.length; i += 1) {
                const item = this.pageData.amountComparisonForm[i];
                this.pageData.amountComparisonForm[i].comparisonPercent = this.countDiffPercent(item.amountA, item.amountB);
            }

            // 總比較長條圖
            this.allChartOption.series[0].data = [this.pageData.amountComparisonForm[0].amountA, this.pageData.amountComparisonForm[1].amountA, this.pageData.amountComparisonForm[2].amountA];

            this.allChartOption.series[1].data = [this.pageData.amountComparisonForm[0].amountB, this.pageData.amountComparisonForm[1].amountB, this.pageData.amountComparisonForm[2].amountB];

            // 收入
            let incomeSumA = 0;
            let incomeSumB = 0;
            let incomeSumAtax = 0;
            let incomeSumBtax = 0;
            const incomeItemsA = [];
            const incomeItemsB = [];
            const incomeTypeItems = [];
            for (let i = 0; i < this.pageData.incomeComparisonForm.length; i += 1) {
                const item = this.pageData.incomeComparisonForm[i];
                incomeSumA += item.noTaxAmountA;
                incomeSumB += item.noTaxAmountB;
                incomeSumAtax += Math.round(item.taxA);
                incomeSumBtax += Math.round(item.taxB);

                incomeItemsA.push(item.noTaxAmountA);
                incomeItemsB.push(item.noTaxAmountB);
                incomeTypeItems.push(item.title);

                // 補計算差值
                const ic = item.noTaxAmountB + item.taxB - (item.noTaxAmountA + item.taxA);
                this.pageData.incomeComparisonForm[i].comparisonValue = ic;

                // 百分比格式化
                this.pageData.incomeComparisonForm[i].comparisonPercent = this.countDiffPercent(item.noTaxAmountA + item.taxA, item.noTaxAmountB + item.taxB);
            }

            // 收入長條圖
            this.incomeChartOption.xAxis.data = incomeTypeItems;
            this.incomeChartOption.series[0].data = incomeItemsA;
            this.incomeChartOption.series[1].data = incomeItemsB;

            // 收入 補總計
            this.pageData.incomeComparisonForm.push({
                title: '合計',
                noTaxAmountA: incomeSumA,
                noTaxAmountB: incomeSumB,
                taxA: incomeSumAtax,
                taxB: incomeSumBtax,
                comparisonValue: incomeSumB - incomeSumA,
                comparisonPercent: this.countDiffPercent(incomeSumA, incomeSumB),
            });

            // 支出
            let payoutSumA = 0;
            let payoutSumB = 0;
            const payoutItemsA = [];
            const payoutItemsB = [];
            const payoutTypeItems = [];
            for (let i = 0; i < this.pageData.payoutComparisonForm.length; i += 1) {
                const item = this.pageData.payoutComparisonForm[i];

                payoutSumA += item.amountA;
                payoutSumB += item.amountB;

                payoutItemsA.push(item.amountA);
                payoutItemsB.push(item.amountB);
                payoutTypeItems.push(item.title);

                // 補計算差值
                const pc = item.amountB - item.amountA;
                this.pageData.payoutComparisonForm[i].comparisonValue = pc;

                // 百分比格式化
                this.pageData.payoutComparisonForm[i].comparisonPercent = this.countDiffPercent(item.amountA, item.amountB);
            }

            // 支出長條圖
            this.payoutChartOption.xAxis.data = payoutTypeItems;
            this.payoutChartOption.series[0].data = payoutItemsA;
            this.payoutChartOption.series[1].data = payoutItemsB;

            // 支出 補總計
            this.pageData.payoutComparisonForm.push({
                title: '合計',
                amountA: payoutSumA,
                amountB: payoutSumB,
                comparisonValue: payoutSumB - payoutSumA,
                comparisonPercent: this.countDiffPercent(payoutSumA, payoutSumB),
            });
        },

        handleStartMonthAChange() {
            this.conditions.StartMonthB = this.conditions.StartMonthA;
        },

        handleEndMonthAChange() {
            this.conditions.EndMonthB = this.conditions.EndMonthA;
        },

        onToggleIncomeTaxJoin() {
            this.isIncomeTaxJoin = !this.isIncomeTaxJoin;
        },
        getIncomeComparisonValue(item) {
            if (this.isIncomeTaxJoin) return item.comparisonValue;
            return item.noTaxAmountB - item.noTaxAmountA;
        },
        getIncomeComparisonPercent(item) {
            if (this.isIncomeTaxJoin) return Math.abs(item.comparisonPercent);
            return Math.abs(this.countDiffPercent(item.noTaxAmountA, item.noTaxAmountB));
        },

        checkIsValidPercentNumber(item) {
            return Number.isFinite(item.comparisonPercent) && !Number.isNaN(item.comparisonPercent);
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.analysis-compare-page {
    $border-color: #e3e3e3;

    .a-font {
        color: #4253bf;
        font-weight: bold;
    }

    .b-font {
        color: #ffa200;
        font-weight: bold;
    }

    .compare-table2 {
        border: 1px solid $border-color;
        width: 100%;
        font-size: 10.5pt;
        color: #333;
        border-radius: 12px;
        overflow: hidden;

        th {
            border-right: 1px solid $border-color;
            border-bottom: 1px solid $border-color;
            text-align: center;
            padding: 10px;

            &:last-child {
                border-right: none;
            }

            &.item-b {
                border-bottom: 3px solid #ffa200;
                background-color: #fff5e3;

                .title {
                    color: #ffa200;
                    font-weight: bold;
                }

                .head-date {
                }
            }

            &.item-a {
                .title {
                    color: $main-color;
                    font-weight: bold;
                }

                .head-date {
                }

                border-bottom: 3px solid $main-color;
                background-color: $main-color-fade;
            }
        }

        td {
            border-right: 1px solid $border-color;
            border-bottom: 1px solid $border-color;
            padding: 3px 10px;

            &:last-child {
                border-right: none;
            }

            &.item-name {
                padding-left: 22px;
                background-color: #f9f9f9;
                color: #000;
                width: 20%;
            }

            &.td-center {
                text-align: center;
            }

            &.item-a,
            &.item-b,
            &.item-amt,
            &.item-percent {
                text-align: right;
                font-weight: bold;
                width: 24%;
            }

            &.item-amt {
                width: 18%;
            }

            &.no-tax {
                width: 16%;
            }
            &.tax {
                width: 8%;
            }

            &.item-percent {
                width: 14%;
            }

            &.item-hr {
                background-color: #eceff8;
                color: #4253bf;
                font-weight: bold;
                padding: 5px 10px;
            }
        }

        tr:last-child {
            td {
                border-bottom: none;
            }
        }

        tr:hover {
            td:not(.item-hr) {
                background-color: #f4f8ff;
            }
        }
    }

    .diff-sign {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        width: 16px;
        height: 16px;
        background-color: #ccc;
        margin-right: 5px;
        border-radius: 4px;

        &.increase {
            background-color: #cfeecb;

            &:before {
                content: "";
                display: block;
                position: absolute;
                top: 7px;
                left: 4px;
                width: 8px;
                height: 2px;
                background-color: #10a900;
            }

            &:after {
                content: "";
                display: block;
                position: absolute;
                transform: rotate(90deg);
                top: 7px;
                left: 4px;
                width: 8px;
                height: 2px;
                background-color: #10a900;
            }
        }

        &.decrease {
            background-color: #fadbdb;

            &:before {
                content: "";
                display: block;
                position: absolute;
                top: 7px;
                left: 4px;
                width: 8px;
                height: 2px;
                background-color: red;
            }
        }
    }

    .chart-labels {
        text-align: center;

        .item {
            display: inline-block;
            background-color: #ccc;
            margin: 0 10px;
            padding: 5px 13px 5px 10px;
            border-radius: 15px;

            &.a {
                background-color: $main-color-fade;

                .title {
                    color: $main-color;
                }
            }

            &.b {
                background-color: #fff5e3;

                .title {
                    color: #ffa200;
                }
            }

            .title {
                float: left;
                font-weight: bold;
                font-size: 13pt;
                margin: 0 15px 0 5px;
            }

            .timespan {
                float: left;
                font-size: 10pt;
            }
        }
    }
}
</style>
